import { loadEpic } from './state/load.epic';

export const behaviourSelectionDialogEpics = [loadEpic];
